export default "__VITE_ASSET__BzXO5lSt__"